import { render, staticRenderFns } from "./BrandingCampaign.vue?vue&type=template&id=1443d5a8&"
import script from "./BrandingCampaign.vue?vue&type=script&lang=js&"
export * from "./BrandingCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports